import React from 'react';
import FormalQuoteForm from 'formal_quote/components/FormalQuoteForm';

const FormalQuotePage = () => (
  <div className="formal-quote-page">
    <div
      className="container-fluid px-0"
      style={{ backgroundColor: '#F8F9FC' }}
    >
      <div className="banner">
        <div className="container-lg">
          <h1 className="title">Software Product Formal Quote</h1>
          <p className="subtitle">
            Get a formal quote to send your purchase manager.
          </p>
        </div>
      </div>

      <div className="container-lg form-container">
        <div className="row">
          <div className="col-12">
            <div className="card">
              <div className="card-body">
                <h2 className="title">
                  Please fill the form below to send you a formal quote for software product
                </h2>
                <FormalQuoteForm />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default FormalQuotePage;
